import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=01d0a159&"
var script = {}
import style0 from "./AlertModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports